import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useMediaQueries, useQueryParams} from 'presentation/pages';

export function useOdontoUnitsSupportAccredited() {
	const {specialtyName, isManualLocation, hasGeoDistrictsFilter} = useBookingStore(
		state => state.bookingData,
	);

	const {isMobile} = useMediaQueries();
	const {
		SEARCH_PARAMS: {query},
	} = useQueryParams();

	const shouldShowDistanceReference = !isManualLocation && !hasGeoDistrictsFilter;

	return {
		query,
		isMobile,
		specialtyName,
		shouldShowDistanceReference,
	};
}
